import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, MetaGovernoOds } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class MetaGovernoOdsService extends BaseResourceService<MetaGovernoOds> {

  constructor(
    protected injector: Injector
  ) {
    super(`metas-governo-ods`, injector);
  }

}
